import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

export const StyledContainer = styled.div`
  margin: 0 auto;
  max-width: 65rem;
`;

export const StyledWrapper = styled.div`
  width: 100%;
  padding: 0 1rem 3rem;
  box-sizing: border-box;
  margin: auto;
  max-width: 65rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 0 1rem 4rem;
  }
`;

export const StyledContentWrapper = styled(StyledWrapper)`
  padding: 0 1rem 2rem;
  @media (min-width: ${breakpoints.md}) {
    padding: 0 1rem 2rem;
  }
`;

export const StyledPageWrapper = styled.div`
  width: 100%;
`;
